// Compat shim: use o helper genérico em src/lib/antispam.ts.
// Scope legado "ouvidoria" mantido para compatibilidade de chaves de cooldown.
import {
  checkAntispam as checkAntispamCore,
  markAntispamSubmitted as markAntispamSubmittedCore,
  type AntispamCheck,
} from "./antispam";

const SCOPE = "ouvidoria";

export type { AntispamCheck };

export function checkAntispam(opts: {
  honeypot: string;
  formOpenedAt: number;
  contentKey: string;
}) {
  return checkAntispamCore({
    scope: SCOPE,
    honeypot: opts.honeypot,
    formOpenedAt: opts.formOpenedAt,
    contentKey: opts.contentKey,
    cooldownMs: 60_000,
    minFillMs: 3_000,
  });
}

export function markAntispamSubmitted(hash: string) {
  markAntispamSubmittedCore(SCOPE, hash);
}
